import { render, staticRenderFns } from "./EvntProcessInfoModal.vue?vue&type=template&id=6ccfe5ea&"
import script from "./EvntProcessInfoModal.vue?vue&type=script&lang=js&"
export * from "./EvntProcessInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports